import { render, staticRenderFns } from "./ValidTables.vue?vue&type=template&id=dbaf6274&scoped=true&"
import script from "./ValidTables.vue?vue&type=script&lang=js&"
export * from "./ValidTables.vue?vue&type=script&lang=js&"
import style0 from "./ValidTables.vue?vue&type=style&index=0&id=dbaf6274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaf6274",
  null
  
)

export default component.exports